// extracted by mini-css-extract-plugin
module.exports = {"labelMargin":"popupGenerateEmployeesReport_labelMargin__2n1TQ"};